<mat-icon aria-hidden="true">{{ icon() }}</mat-icon>
